import { X } from "lucide-react";

import { Input } from "../../components/ui/input";


/* ---------------------- Inline Picture Uploader ------------------------- */

export const PictureUploader = ({ picture, onUpload, onRemove }) => {
  const handleFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    onUpload(f);
  };
  return (
    <div className="flex items-center gap-4">
      <label className="flex flex-col gap-1">
        <span className="text-sm font-medium">Upload picture</span>
        <Input type="file" accept="image/*" onChange={handleFile} />
      </label>

      {picture && (
        <div className="relative">
          <img
            src={picture instanceof File ? URL.createObjectURL(picture) : picture}
            alt="preview"
            className="w-20 h-20 rounded-full object-cover"
          />
          <button
            onClick={onRemove}
            className="absolute -top-1 -right-1 bg-background rounded-full p-1 shadow"
            aria-label="Remove"
          >
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
};
